import { call, takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, requestSaga } from "shared-utility/store/utils/helpers";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { downloadXLSFile } from "utils/api";

const initialState = {
  dealScreener: [],
  dealScreenerFiltered: [],
  savedFilters: [],
  newSavedFilter: {}
};

export const GET_DEAL_SCREENER_DATA = generateDefaultActions("GET_DEAL_SCREENER_DATA");
export const getDealScreenerData = payload => makePayload(GET_DEAL_SCREENER_DATA.value, payload);
function* getDealScreenerDataSaga() {
  const url = "/dealScreener";
  yield requestSaga(GET_DEAL_SCREENER_DATA, url, "GET");
}

export const EXPORT_SCREENER_DATA = generateDefaultActions("EXPORT_SCREENER_DATA");
export const exportDealScreenerData = payload => makePayload(EXPORT_SCREENER_DATA.value, payload);
function* exportDealScreenerDataSaga(payload) {
  const url = "exportDealScreener";
  yield call(downloadXLSFile, url, "POST", payload, "");
}

export const FILTER_SCREENER = generateDefaultActions("FILTER_SCREENER");
export const filterScreenerData = payload => makePayload(FILTER_SCREENER.value, payload);
function* filterScreenerSaga(payload) {
  const url = "/dealScreenerFiltered";
  yield requestSaga(FILTER_SCREENER, url, "POST", payload);
}

export const GET_SAVED_DEAL_SCREENER_FILTERS = generateDefaultActions("GET_SAVED_DEAL_SCREENER_FILTERS");
export const getSavedDealScreenerFilters = payload => makePayload(GET_SAVED_DEAL_SCREENER_FILTERS.value, payload);
function* getSavedDealScreenerFiltersSaga() {
  const url = "/dealScreener/filters";
  yield requestSaga(GET_SAVED_DEAL_SCREENER_FILTERS, url, "GET");
}

export const SAVE_NEW_DEAL_SCREENER_FILTER = generateDefaultActions("SAVE_NEW_DEAL_SCREENER_FILTER");
export const saveNewDealScreenerFilter = payload => makePayload(SAVE_NEW_DEAL_SCREENER_FILTER.value, payload);
function* saveNewDealScreenerFilterSaga(payload) {
  const url = "/dealScreener/filters/user";
  yield requestSaga(SAVE_NEW_DEAL_SCREENER_FILTER, url, "POST", payload, "");
}

export const UPDATE_DEAL_SCREENER_FILTER_PRESET = generateDefaultActions("UPDATE_DEAL_SCREENER_FILTER_PRESET");
export const updateDealScreenerFilterPreset = payload => makePayload(UPDATE_DEAL_SCREENER_FILTER_PRESET.value, payload);
function* updateDealScreenerFilterPresetSaga(payload) {
  const url = "/dealScreener/filters";
  yield requestSaga(UPDATE_DEAL_SCREENER_FILTER_PRESET, url, "PUT", payload);
}

export const DELETE_DEAL_SCREENER_FILTER_PRESET = generateDefaultActions("DELETE_DEAL_SCREENER_FILTER_PRESET");
export const deleteDealScreenerFilterPreset = payload => makePayload(DELETE_DEAL_SCREENER_FILTER_PRESET.value, payload);
function* deleteDealScreenerFilterPresetSaga(payload) {
  const url = "/dealScreener/filters";
  yield requestSaga(DELETE_DEAL_SCREENER_FILTER_PRESET, url, "DELETE", payload);
}

export const dealScreenerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DEAL_SCREENER_DATA.success:
      return defaultReturn(state, payload.data, "dealScreener");

    case GET_DEAL_SCREENER_DATA.failure:
      ToastError("Getting deal screener data failed");

      return defaultReturn(state, payload.data);

    case FILTER_SCREENER.success:
      return defaultReturn(state, payload.data, "dealScreenerFiltered");

    case FILTER_SCREENER.failure:
      ToastError("Getting filtered deal screener data failed");

      return defaultReturn(state, payload.data);

    case EXPORT_SCREENER_DATA.success:
      ToastSuccess("Screener Data Exported");

      return defaultReturn(state, payload.data);

    case EXPORT_SCREENER_DATA.failure:
      ToastError("Screener Data Export Failed");

      return defaultReturn(state, payload.data);

    case GET_SAVED_DEAL_SCREENER_FILTERS.success:
      return defaultReturn(state, payload.data, "savedFilters");

    case GET_SAVED_DEAL_SCREENER_FILTERS.failure:
      ToastError("Getting Saved Filters Failed");

      return defaultReturn(state, payload.data);

    case SAVE_NEW_DEAL_SCREENER_FILTER.success:
      ToastSuccess("Successfully saved filter");

      return defaultReturn(state, payload.data, "newSavedFilter");

    case SAVE_NEW_DEAL_SCREENER_FILTER.failure:
      ToastError("Saving filter failed");

      return defaultReturn(state, payload.data);

    case UPDATE_DEAL_SCREENER_FILTER_PRESET.success:
      ToastSuccess("Successfully updated filter");

      return defaultReturn(state, payload.data, "newSavedFilter");

    case UPDATE_DEAL_SCREENER_FILTER_PRESET.failure:
      ToastError("Failed to update filter");

      return defaultReturn(state, payload.data);

    case DELETE_DEAL_SCREENER_FILTER_PRESET.success:
      ToastSuccess("Successfully deleted filter");

      return defaultReturn(state, payload.data);

    case DELETE_DEAL_SCREENER_FILTER_PRESET.failure:
      ToastError("Failed to delete filter");

      return defaultReturn(state, payload.data);

    default: return state;
  }
};

export function* dealScreenerSaga() {
  yield takeLatest(GET_DEAL_SCREENER_DATA.value, getDealScreenerDataSaga);
  yield takeLatest(EXPORT_SCREENER_DATA.value, exportDealScreenerDataSaga);
  yield takeLatest(FILTER_SCREENER.value, filterScreenerSaga);
  yield takeLatest(GET_SAVED_DEAL_SCREENER_FILTERS.value, getSavedDealScreenerFiltersSaga);
  yield takeLatest(SAVE_NEW_DEAL_SCREENER_FILTER.value, saveNewDealScreenerFilterSaga);
  yield takeLatest(UPDATE_DEAL_SCREENER_FILTER_PRESET.value, updateDealScreenerFilterPresetSaga);
  yield takeLatest(DELETE_DEAL_SCREENER_FILTER_PRESET.value, deleteDealScreenerFilterPresetSaga);
}
